import { SET_BULK_FORM_SELECTIONS } from "constants-lib/actionTypes"

export const setOaklandBulkFormSelections = (data) => (dispatch) =>
  dispatch({
    type: SET_BULK_FORM_SELECTIONS,
    payload: data,
  })
